<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div *ngIf="getFormAt(1)" class="width-33">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="getFormAt(1).get('addressType').value + ' address'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="getFormAt(1)"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['AddressEditComponent', 'address', ''+1])"
          (undo)="undo(['addresses', ''+1])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>

      <div class="width-33">
        <storever-element-group
          [icon]="'fa-address-book'"
          [title]="getFormAt(0).get('addressType').value + ' address'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="getFormAt(0)"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['AddressEditComponent', 'address', ''+0])"
          (undo)="undo(['addresses', ''+0])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
    </ul>
  </form>
</ng-template>

<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
<!--  <pre>getFormAt(0) value: {{getFormAt(0).value | json}}</pre>-->
<!--  <pre *ngIf="getFormAt(1)">getFormAt(1) value: {{getFormAt(1).value | json}}</pre>-->
  <pre>getFormAt(0) dirty: {{getFormAt(0).dirty}}</pre>
  <pre *ngIf="getFormAt(1)">getFormAt(1) dirty: {{getFormAt(1).dirty}}</pre>
</div>

